import type { Component } from 'vue';

const load = () => import('./ui/index.vue');

export const ComplaintModal: Component = defineAsyncComponent(() =>
  load().then((m: { default: Component }) => m.default),
);

export const prefetchComplaintModal = (): void => {
  load().catch(() => null);
};
